export default __webpack_public_path__ + "static/media/region.f1545892.svg";